import { render } from "./BaseFileInput.vue?vue&type=template&id=53d74b49&scoped=true"
import script from "./BaseFileInput.vue?vue&type=script&lang=js"
export * from "./BaseFileInput.vue?vue&type=script&lang=js"

import "./BaseFileInput.vue?vue&type=style&index=0&id=53d74b49&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d74b49"]])

export default __exports__